<template>
  <div class="role-details">
    <template v-if="isLoaded">
      <template v-if="isFailed">
        <error-message
          :message="'role-details.default-error-message' | globalize" />
      </template>
      <template v-else>
        <div class="app__block role-details__details">
          <h2 class="role-details__title">
            {{ "role-details.title-details" | globalize }}
          </h2>
          <ul class="app-key-value__list">
            <li class="app-key-value__row">
              <span class="app-key-value__key">
                {{ 'role-details.lbl-name' | globalize }}
              </span>
              <span
                class="app-key-value__value"
                :title="role.name"
              >
                {{ role.name || '-' }}
              </span>
            </li>
            <li class="app-key-value__row">
              <span class="app-key-value__key">
                {{ 'role-details.lbl-description' | globalize }}
              </span>
              <permission-wrapper
                skip-alert
                :message="role.description"
                page-name="roles"
                resource-name="role"
                action-name="update">
                <editable-content-field
                  class="app-key-value__value"
                  :details-value.sync="role.description"
                  :editable.sync="isDescriptionEditable"
                  @on-save="updateRoleDetails"
                />
              </permission-wrapper>
            </li>
          </ul>
        </div>

        <div class="role-details__wrp">
          <div class="role-details__resources app__block">
            <role-resources
              :role-details="role"
              :resource="selectedResource"
              @set-resource="selectResource"
              @set-role="setRole"
            />
          </div>
          <div class="role-details__permissions app__block">
            <role-actions
              :role-details="role"
              :resource="selectedResource"
              @set-resource="setDefaultResource"
              @update-role="updateRoleResource"
            />
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <loader
        message-id="loading"
        position-center
      />
    </template>
  </div>
</template>

<script>
import EditableContentField from '@/vue/fields/EditableContentField'
import RolesMixin from '@/vue/mixins/roles.mixin'
import RoleActions from './components/RoleActions'
import RoleResources from './components/RoleResources'
import _isEmpty from 'lodash/isEmpty'
import PermissionWrapper from '@/vue/common/permission-wrapper'

export default {
  name: 'role-details',
  components: {
    RoleActions,
    RoleResources,
    EditableContentField,
    PermissionWrapper,
  },
  mixins: [ RolesMixin ],
  props: {
    id: { type: [String, Number], required: true },
  },

  data () {
    return {
      selectedResource: '',
      isNameEditable: false,
      isDescriptionEditable: false,
      role: {},
    }
  },

  computed: {
    resourceExists () {
      return Boolean(this.role.permissions.find(item =>
        item.resource === this.selectedResource))
    },
  },

  async created () {
    await this.getRoleById(this.id)
    this.setDefaultResource()
  },

  methods: {
    setDefaultResource () {
      if (!_isEmpty(this.role.permissions) && !this.resourceExists) {
        this.selectedResource = this.role.permissions[0].resource || ''
      }
    },

    selectResource (resource) {
      this.selectedResource = resource
    },

    setRole (newRole) {
      this.role = newRole
    },

    async updateRoleDetails () {
      await this.updateRole(this.role.id)
      this.getRoleById(this.role.id)
    },

    async updateRoleResource () {
      await this.getRoleById(this.id)
      this.selectedResource = ''
      this.setDefaultResource()
    },
  },
}
</script>

<style lang="scss" scoped>
.role-details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 4rem;
}

.role-details__title {
  margin-bottom: 4rem;
}

.role-details__actions {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  max-width: 55rem;
  width: 100%;
}

.role-details__details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.role-details__wrp {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 4rem;
}

.role-details__resources {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  gap: 2rem;
}
</style>
